import { useState, useEffect } from 'react';
import ErrorLogsPanel from '@/components/admin/ErrorLogsPanel';
import { API } from '@/App';

export default function AdminErrorsPage() {
  const [errorLogs, setErrorLogs] = useState([]);

  useEffect(() => {
    fetchErrorLogs();
  }, []);

  const fetchErrorLogs = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API}/admin/error-logs`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        setErrorLogs(await response.json());
      }
    } catch (error) {
      console.error('Error fetching logs:', error);
    }
  };

  return <ErrorLogsPanel errorLogs={errorLogs} onRefresh={fetchErrorLogs} />;
}
